import { ResizeMode } from '@dave/types';

export enum imageQualityEnum {
    default,
    custom,
    original,
}
export const defaultResizePixel = 400;
export const imageQualityOptions = [
    {
        value: imageQualityEnum.default,
        label: 'standard',
    },
    {
        value: imageQualityEnum.original,
        label: 'original',
    },
    {
        value: imageQualityEnum.custom,
        label: 'benutzerdefiniert',
    },
]

export const getExportOptions = ({
    imageQuality,
    exportWorkTimes,
    showFooter,
    imageColCount,
    imageMinRowCount,
    imageQualityPX,
}: {
    imageQuality?: imageQualityEnum;
    exportWorkTimes?: boolean;
    showFooter?: boolean;
    imageColCount?: 1 | 2 | 3;
    imageMinRowCount?: 1 | 2 | 3;
    imageQualityPX?: number | null;
}) => {
    const pixels = imageQuality === imageQualityEnum.custom ? imageQualityPX : imageQuality === imageQualityEnum.default ? defaultResizePixel : undefined;
    return {
        exportWorkTimes: !!exportWorkTimes,
        hideFooter: !showFooter,
        imageColumns: imageColCount,
        imageColumnHeight: imageMinRowCount + '',
        resizeMode: imageQuality === imageQualityEnum.original ? ResizeMode.None : ResizeMode.Fit,
        width: pixels,
        height: pixels,
    };
};
